import { Layer, Rect, Line, Image as KonvaImage } from "react-konva";

// Background map image + grid line rendering (square/hex/gridless), extracted verbatim from
// MapCanvas.jsx (Phase 42 refactor) — no behavior changes.
export function MapGridBackground({ game, gridSize, width, height, mapImage }) {
  const renderGridLines = () => {
    if (!game || game.grid_type === "gridless") return null;
    const lines = [];
    // Flat-top hexagons sized so their circumradius (R) equals half a square cell — this keeps
    // hex cells visually consistent with the square grid's spacing at the same grid_size value.
    if (game.grid_type === "hex") {
      const R = gridSize / 2;
      const colSpacing = R * 1.5;
      const rowSpacing = R * Math.sqrt(3);
      for (let col = 0; col < width / colSpacing + 2; col++) {
        for (let row = 0; row < height / rowSpacing + 2; row++) {
          const cx = col * colSpacing;
          const cy = row * rowSpacing + (col % 2 ? rowSpacing / 2 : 0);
          const pts = [];
          for (let i = 0; i < 6; i++) {
            const angle = (Math.PI / 3) * i;
            pts.push(cx + R * Math.cos(angle), cy + R * Math.sin(angle));
          }
          lines.push(
            <Line
              key={`h${row}-${col}`}
              points={[...pts, pts[0], pts[1]]}
              stroke="#000000d0"
              strokeWidth={1.5}
              shadowColor="#ffffff"
              shadowBlur={2.5}
              shadowOpacity={0.45}
              closed
              listening={false}
            />
          );
        }
      }
      return lines;
    }
    for (let x = 0; x <= width; x += gridSize) lines.push(<Line key={`v${x}`} points={[x, 0, x, height]} stroke="#000000d0" strokeWidth={1.5} shadowColor="#ffffff" shadowBlur={2.5} shadowOpacity={0.45} listening={false} />);
    for (let y = 0; y <= height; y += gridSize) lines.push(<Line key={`hz${y}`} points={[0, y, width, y]} stroke="#000000d0" strokeWidth={1.5} shadowColor="#ffffff" shadowBlur={2.5} shadowOpacity={0.45} listening={false} />);
    return lines;
  };

  return (
    <Layer>
      <Rect x={0} y={0} width={width} height={height} fill="#1a1719" listening={false} />
      {mapImage && <KonvaImage image={mapImage} x={0} y={0} width={width} height={height} listening={false} />}
      {renderGridLines()}
    </Layer>
  );
}
